import { mount } from "svelte";
import FloatingActionButton from "./components/pages/FloatingActionButton.svelte";
import { ShopIntegrationService } from "./lib/ShopIntegrationService";
import { tracking } from "./lib/Tracking";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

const target = document.getElementById("cassandra-floating-btn");
const shopIntegration = new ShopIntegrationService();

function trackChatBotViews(isLoggedInUserInApp: boolean, bannerCanBeShown: boolean) {
    if (!isLoggedInUserInApp) return;

    if (bannerCanBeShown) {
        tracking.submitMerge({ san_ChatBotView: ["banner"] });
        /*                                                                                                                                */
        /*                                                                                                         */
        eventQBus.on("ftfind.dresonRule.resolved", () => {
            tracking.submitMerge({ san_ChatBotView: ["banner"] });
        });
    }

    tracking.submitMerge({ san_ChatBotView: ["actionButton"] });

    /*                                                                                                                                */
    /*                                                                                                         */
    eventQBus.on("ftfind.dresonRule.resolved", () => {
        tracking.submitMerge({ san_ChatBotView: ["actionButton"] });
    });
}

(async () => {
    if (!target) return;

    const canShowChatbotEntrypoint = await shopIntegration.canShowChatbotEntrypoint();
    if (!canShowChatbotEntrypoint) return;

    const [isLoggedInUserInApp, showFloatingActionButton] = await Promise.all([shopIntegration.isLoggedInUserInApp(), shopIntegration.shouldShowButton()]);
    const canBeBanner = shopIntegration.buttonCanBeBanner();
    const canBeExpanded = shopIntegration.buttonCanBeExpandable();

    trackChatBotViews(isLoggedInUserInApp, canBeBanner);

    if (showFloatingActionButton) {
        mount(FloatingActionButton, {
            target,
            props: { href: "/chat", canBeBanner, canBeExpanded },
        });
    }
})();
